import DOMPurify from 'isomorphic-dompurify';

export const RICH_HTML_ALLOWED_TAGS = ['a', 'b', 'br', 'em', 'i', 'li', 'ol', 'p', 'strong', 'u', 'ul'] as const;

const ALLOWED_TAGS = [...RICH_HTML_ALLOWED_TAGS];
const ALLOWED_ATTR = ['href', 'rel', 'target'];
const UNSAFE_HREF = /^(javascript|data|vbscript):/i;
const SAFE_HREF = /^(https?:\/\/|\/|#)/i;

let hooksRegistered = false;

function isSafeHref(href: string): boolean {
  const trimmed = href.trim();
  if (!trimmed || UNSAFE_HREF.test(trimmed)) return false;
  return SAFE_HREF.test(trimmed);
}

function registerHooks() {
  if (hooksRegistered) return;
  hooksRegistered = true;

  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName !== 'A') return;

    const href = node.getAttribute('href');
    if (!href || !isSafeHref(href)) {
      node.removeAttribute('href');
    }

    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  });
}

export function sanitizeRichHtml(html: string | null | undefined): string {
  registerHooks();
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed'],
    FORBID_CONTENTS: ['script', 'style', 'iframe'],
  }).trim();
}

export function isEmptyRichHtml(html: string | null | undefined): boolean {
  const sanitized = sanitizeRichHtml(html);
  if (!sanitized) return true;

  const text = sanitized
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();

  return text.length === 0;
}
